module.exports = __webpack_public_path__ + "img/tempD.9f4f5cd2.png";